/* bmcC-collection.js (builder C, whole-store Josh pass 2026-09-28). Collection pages only. */
(function () {
  if (window.bmcCCollection) return;
  window.bmcCCollection = true;

  // C4: the Sort select on the phone bar drives Dawn's own drawer select, so facets.js refreshes the grid as today.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-bmcc-sort]')) {
      var d = document.getElementById('SortBy-mobile');
      if (!d || !window.customElements || !customElements.get('facet-filters-form')) {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', t.value);
        u.searchParams.delete('page');
        window.location.href = u.toString();
        return;
      }
      d.value = t.value;
      d.dispatchEvent(new Event('input', { bubbles: true }));
    } else if (t.id === 'SortBy-mobile') {
      document.querySelectorAll('[data-bmcc-sort]').forEach(function (s) { s.value = t.value; });
    }
  });

  // Back/Forward: Dawn re-renders its own sort selects only, so the phone bar Sort follows the URL here.
  window.addEventListener('popstate', function () {
    var sb = new URLSearchParams(window.location.search).get('sort_by');
    document.querySelectorAll('[data-bmcc-sort]').forEach(function (s) {
      var v = sb || s.getAttribute('data-bmcc-default');
      if (!v) return;
      for (var i = 0; i < s.options.length; i++) if (s.options[i].value === v) { s.value = v; break; }
    });
  });

  // C24: on phones the chip row scrolls sideways; bring the current topic into view so shoppers see where they are.
  function bmcCChipsInView() {
    document.querySelectorAll('.bmcC-topics__list').forEach(function (l) {
      var on = l.querySelector('.bmcC-chip--on');
      if (!on || l.scrollWidth <= l.clientWidth) return;
      var li = on.parentElement || on;
      if (li.offsetLeft + li.offsetWidth > l.scrollLeft + l.clientWidth || li.offsetLeft < l.scrollLeft) {
        l.scrollLeft = Math.max(0, li.offsetLeft - 16);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bmcCChipsInView); else bmcCChipsInView();

  // C29: a topic chip keeps the filters (price range) and a chosen sort, so topic and price combine.
  // The crawlable href stays the plain collection URL; the query is added only when a shopper uses the chip.
  function bmcCChip(a) {
    var base = a.getAttribute('data-bmcc-base');
    if (!base) { base = a.getAttribute('href'); a.setAttribute('data-bmcc-base', base); }
    var nav = a.closest('[data-bmcc-default-sort]');
    var def = nav ? nav.getAttribute('data-bmcc-default-sort') : '';
    var keep = new URLSearchParams();
    new URLSearchParams(window.location.search).forEach(function (v, k) {
      if (k.indexOf('filter.') === 0 || (k === 'sort_by' && v !== def)) keep.append(k, v);
    });
    var qs = keep.toString();
    a.setAttribute('href', base + (qs ? '?' + qs : ''));
  }
  ['click', 'auxclick', 'contextmenu', 'focusin', 'mouseover', 'touchstart'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a.bmcC-chip') : null;
      if (a) bmcCChip(a);
    }, { capture: true, passive: true });
  });

  // C33: range sliders write whole numbers into Dawn's From/To fields; the facet form then submits as usual.
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-bmcc-target]')) return;
    var box = t.closest('[data-bmcc-range]');
    if (box) {
      var lo = box.querySelector('[data-bmcc-role="min"]');
      var hi = box.querySelector('[data-bmcc-role="max"]');
      if (lo && hi && Number(lo.value) > Number(hi.value)) {
        if (t === lo) lo.value = hi.value; else hi.value = lo.value;
      }
    }
    var f = document.getElementById(t.getAttribute('data-bmcc-target'));
    if (f) f.value = t.value;
  });
})();

/* W2C: keep --bmcC-header-h equal to the header's real height, for the sticky filter bar (C32). */
(function () {
  if (window.bmcCHeaderH) return;
  window.bmcCHeaderH = true;
  var h = document.querySelector('.section-header');
  if (!h) return;
  function set() {
    var v = h.offsetHeight;
    if (v > 0) document.documentElement.style.setProperty('--bmcC-header-h', v + 'px');
  }
  set();
  if (window.ResizeObserver) new ResizeObserver(set).observe(h);
  window.addEventListener('load', set);
  window.addEventListener('resize', set);
})();

/* W4C (wave 4, C9): back from a product page lands on the same card. The browser's own restore is left alone; this
   only acts when the page comes back through history (bfcache, or a back_forward reload that the app embeds force)
   and the position misses by more than 50px. Collection pages only (this file loads there). sessionStorage only. */
(function () {
  if (window.bmcW4CBack) return;
  window.bmcW4CBack = true;
  var KEY = 'bmcW4C-back';
  function here() { return location.pathname + location.search; }
  function read() { try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function save(y) { try { sessionStorage.setItem(KEY, JSON.stringify({ p: here(), y: y, t: Date.now() })); } catch (e) {} }
  function clear() { try { sessionStorage.removeItem(KEY); } catch (e) {} }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('#product-grid a[href*="/products/"]') : null;
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    save(window.scrollY || window.pageYOffset || 0);
  }, true);
  window.addEventListener('pageshow', function (ev) {
    var s = read();
    if (!s || s.p !== here() || location.hash) return;
    if (Date.now() - s.t > 30 * 60 * 1000) { clear(); return; }
    var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || null;
    var back = (ev && ev.persisted) || (nav && nav.type === 'back_forward');
    if (!back) return;
    var tries = 0;
    (function tick() {
      var y = window.scrollY || window.pageYOffset || 0;
      var max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      if (Math.abs(y - s.y) <= 50) { clear(); return; }
      if (max >= s.y) { window.scrollTo(0, s.y); clear(); return; }
      if (++tries < 60) requestAnimationFrame(tick); else clear();
    })();
  });
})();
